import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
// import useRefreshToken from '../hooks/useRefreshToken';
import useRefreshToken from "../../Hooks/useRefreshToken";
// import useAuth from '../Hooks/UseAuth';
import useAuth from "../../Hooks/UseAuth";
import AuthContext from "../../Context/AuthProvider";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { setAuth } = useContext(AuthContext);
    const { auth, persist } = useAuth();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
                
            }
            catch (err) {
                console.error(err);
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }

        // persist added here AFTER tutorial video
        // Avoids unwanted call to verifyRefreshToken
       
        !auth?.accessToken ? verifyRefreshToken() : setIsLoading(false);
        console.log("auth in perst",auth)
        // !auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);

        return () => isMounted = false;
    // }, [])
    }, [])

    useEffect(() => {
        console.log(`isLoading: ${isLoading}`)
        console.log(`aT: ${JSON.stringify(auth?.accessToken)}`)
    }, [isLoading])

    return (
        <>
            {persist
                ? <Outlet />
                : isLoading
                    ? <p>Loading...</p>
                    : <Outlet />
            }
        </>
    )
}

export default PersistLogin